export const visit = (vm, at) => {
at({ "es": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "caracter\xEDstica disponible", "featureUnavailable": "caracter\xEDstica no disponible" } } } } });
};